// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","header__wrapper":"Header_header__wrapper__5r0kF","header__hamburger":"Header_header__hamburger__dy+Oh","header__logo":"Header_header__logo__rOZQD"};